import { useTranslation } from "react-i18next";
import { H2 } from "@quarks";
import { CardProps } from "@atoms";
import { ProfileCard } from "../styles";
import { ExportsCell } from "@organisms";
import { useIsTeamsApp } from "@hooks";
import { Cards } from "./Cards";
import { WEEKS_BACK } from "./constants";

export const BookingHistoryCard = ({ className, style, ...props }: CardProps) => {
  const { t } = useTranslation();

  const isTeamsApp = useIsTeamsApp();

  if (isTeamsApp) return null;

  return (
    <ProfileCard
      as="section"
      className="pb-8 gap-y-5"
      {...props}>
      <H2>{t("groups:BookingHistory.Title")}</H2>

      <p>{t("groups:BookingHistory.LastWeeksSummary", { count: WEEKS_BACK })}</p>

      <Cards />

      {!isTeamsApp && <ExportsCell />}
    </ProfileCard>
  );
};
